jQuery(document).ready(function($) {

    function checkForm() {
        if ($.trim($(this).val()) != '' || $(this).is(':focus')) {
            $(this).addClass('input--filled');
        } else {
            $(this).removeClass('input--filled');
        }
    }

    $('.input__field').each(checkForm)
    .on('keyup paste change keypress', checkForm)
    .blur(function() {
        $(this).removeClass("input--focused");
    })
    .focus(function() {
        $(this).addClass("input--focused");
        $(this).addClass('input--filled');
    });




    // Валидатор форм
    $.validate({
        lang: 'ru',
        modules: 'html5, security, sanitize, date, file',
        borderColorOnError: '',
        addValidClassOnAll: false,
        dateFormat: 'dd.mm.yyyy'
    });




    // Кастомизатор форм
    jcf.setOptions('Select', {
    	checkedClass: 'custom-select',
    	wrapNative: false
    });

    jcf.setOptions('File', {
    	checkedClass: 'inputfile',
    	buttonText: ' ',
        placeholderText: 'Выберите файл'
    });

    jcf.replaceAll();




    // Accordion
    var allPanels = $('.accordion-item > dd').hide();

    $('.accordion-item > dt > a').click(function () {
        if ($(this).parent().hasClass("show")) {
            allPanels.slideUp().prev("dt").removeClass("show");
        } else {
            if ($(this).prop("hash")) window.location.hash = $(this).prop("hash");
            allPanels.slideUp().prev("dt").removeClass("show");
            $(this).parent().next().slideDown().prev("dt").addClass("show");
        }

        return false;
    });

    var hash = $.trim(window.location.hash);
    if (hash) $('a[href="' + hash + '"]').trigger('click');




    // Submenu
    $('ul.submenu li>.chevron').click(function() {
        console.log('chevron');

        $(this).fadeOut(300);
        $(this).siblings('ul').slideDown(300).addClass('is-active');
        $(this).parent('li').addClass('is-active');
        $('ul.submenu > li:not(".is-active")').slideUp(300);

        $('#open-btn').addClass('get-back');
        $('#open-btn .text').text('назад');
    });


    $('#open-btn').on('click', function(e) { // кнопка НАВИГАЦИЯ
        e.preventDefault();

        if ($(this).hasClass('get-back')) {

            $('ul.submenu ul').slideUp(300).removeClass('is-active');
            $('ul.submenu > li').slideDown(300).removeClass('is-active');
            $('ul.submenu li>.chevron').fadeIn(300);

            $(this).removeClass('get-back');
            $('#open-btn .text').text('навигация');

        } else {

            if ( $('#header-submenu').hasClass('active') ) {
                $('.header-submenu').fadeOut(500).removeClass('active');
                $('.icon-navi').removeClass('rotate');
                $('#header-home').fadeIn(500);

                $('.header--home .header-logo-wrap').fadeOut(300); // логотип на главной


            } else {
                $('.header-submenu').fadeIn(500).addClass('active');
                $('.icon-navi').addClass('rotate');
                $('#header-home').fadeOut(500);

                $('.header--home .header-logo-wrap').fadeIn(500); // логотип на главной

            }
        }
    });

    $('section').on('click', function() { // убирает субменю по клику вне меню
        $('.header-submenu').fadeOut(500).removeClass('active');
    });

    $('#close-btn').on('click', function() { // кнопка в открытом submenu
        $('.header-submenu').fadeOut(500).removeClass('active');
        $('#header-home').fadeIn(500);
        $('.header--home .header-logo-wrap').fadeOut(300);
    });

    $(window).resize(function() {
		if ($(window).width() >= '960') { // для десктопов
			$('.header-submenu').fadeOut(500).removeClass('active');
            $('#overlay').removeClass('is-active');

            $('.header--home .header-logo-wrap').fadeOut(300); // убирает логотив на главной
            $('.header--home #header-home').fadeIn(500); // добавляет шапку на главной
		}
	});

    // matchHeight
    $('.news-item--small').matchHeight({
        byRow: true,
        property: 'height',
    });

    $('.info-box-match').matchHeight({  // выпилить после проверки
        byRow: true,
        property: 'height',
    });

    $('.elements-match').matchHeight({  // для любых элементов в ряду
        byRow: true,
        property: 'height',
    });

    $(window).on("load resize",function() {
        $('.elements-match').matchHeight({  // для любых элементов в ряду
            byRow: true,
            property: 'height',
        });
    });


    // width menu
    function isFit() {
        var widthUl = $('#main-menu').width(),
            widthLi = 0;

        $('#main-menu').find('li:not(.hidden)').each(function(){
            widthLi += $(this).outerWidth();
        });

        if (widthUl > widthLi) {
            return true;
        } else {
            return false;
        }
    }

    $(window).on("load resize",function() {
        if ($(window).width() >= '960') {
            $('#main-menu > li').removeClass('hidden');
            while (!isFit()) {
                $('#main-menu > li:not(.hidden)').last().addClass('hidden');
            }
		}
    });


    // Affix и таймлайн
    var adField = $('#addition-field');
    var adBlock = $('#addition-block');
    var timelineItem = $('.timeline-item');

    adField.affix({
        offset: {
            top: adBlock.offset().top,
            bottom: $(document).height() - adBlock.offset().top - adBlock.innerHeight() + parseInt(adField.css('padding-top'))
        }
    });

    $(window).on("load resize",function() {
        adField.width(adBlock.width());
        adField.affix('checkPosition');

        if ($(window).width() >= '960') {
            timelineItem.find('.addition').slideUp(300);
        } else {
            adField.fadeOut(300);
            timelineItem.removeClass('is-active');
        }
    });

    timelineItem.on('click', function() {
        var additionContent = $(this).find('.addition').html();

        if ($(window).width() >= '960') {
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                adField.fadeOut(300);
            } else {
                timelineItem.removeClass('is-active');
                $(this).addClass('is-active');
                adField.fadeOut(300, function(){
                    adField.html(additionContent).fadeIn(300);
                });
            }
        } else {
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $(this).children('.addition').slideUp(300);
            } else {
                timelineItem.removeClass('is-active');
                timelineItem.find('.addition').slideUp(300);
                $(this).addClass('is-active');
                $(this).children('.addition').slideDown(300);
            }
        }
    });

    // поиск на десктопе

    $('#search-button').on('click', function(sub) { // без поддержки IE, EDGE
        if ($('#search').is(":placeholder-shown")) {
            console.log('не заполнено');
            sub.preventDefault();
        } else {
            console.log('заполнено');
        }
    });



    // поиск на мобильных
    $('#fake-search-button').on('click', function() {
        $('.mob-search-form').fadeIn(300).addClass('is-active');
    });

    $('#search-close-btn').on('click', function() {
        $('.mob-search-form').fadeOut(300).removeClass('is-active');
    });

    $(window).on("load resize",function() {
        $('.mob-search-form').fadeOut(300).removeClass('is-active');
    });



    // Слайдер
    $('.owl-carousel').owlCarousel({
        center: true,
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        mouseDrag: true,
        touchDrag: true,
        nav: true,
        dots: false,
        // animateOut: 'fadeOut'
        // afterAction: function(){
        //     $.each(this.visibleItems, function(_,idx){
        //     });
        // }
    });


    // Preloader
    $(window).load(function() {
        var preloader = $('#preloader');
        preloader.delay(250).fadeOut('slow');
        setTimeout(function remove_preloader() {
            preloader.remove();
        }, 2000);
    });

});
